import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/gov-author-evaluation');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions(
  'gov-evaluation-author',
  validationApi,
);

export function getGovAuthorEvaluationValidationHistoryOptions(
  govAuthorEvaluationId: Id,
): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(govAuthorEvaluationId);
}

export function getGovAuthorEvaluationValidationOptions(
  govAuthorEvaluationId: Id,
): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(govAuthorEvaluationId);
}

export function useValidateGovAuthorEvaluation(govAuthorEvaluationId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(govAuthorEvaluationId, queryClient));
}
